export const departmentFrag = `
    id
    name
    code
    description
`;
